export type ReadingSize = "compact" | "balanced" | "generous";
export type ReadingTheme = "paper" | "night";
export type ReadingMeasure = "focused" | "balanced" | "spacious";
export type LastPracticeView = "discover" | "words" | "expression";

type DevicePreferenceStorage = Pick<Storage, "getItem">;

export type StoredDevicePreferences = {
  currentReadingId: string | null;
  expressionStudyId: string | null;
  expressionStanceId: string | null;
  pronunciationVoiceUri: string;
  readingSize: ReadingSize;
  readingMeasure: ReadingMeasure;
  practiceVisited: boolean;
  lastPracticeView: LastPracticeView;
  theme: ReadingTheme;
};

export function readStoredDevicePreferences(
  storage: DevicePreferenceStorage,
): StoredDevicePreferences {
  const rememberedSize = storage.getItem("verbalore-reading-size");
  const rememberedTheme =
    storage.getItem("verbalore-theme")
    || storage.getItem("weight-of-words-theme");
  const rememberedMeasure = storage.getItem("verbalore-reading-measure");
  const rememberedPractice = storage.getItem("verbalore-last-practice-view");

  return {
    currentReadingId: storage.getItem("verbalore-current-reading"),
    expressionStudyId: storage.getItem("verbalore-expression-study"),
    expressionStanceId: storage.getItem("verbalore-expression-stance"),
    pronunciationVoiceUri:
      storage.getItem("verbalore-pronunciation-voice") || "default",
    readingSize:
      rememberedSize === "compact" || rememberedSize === "generous"
        ? rememberedSize
        : "balanced",
    readingMeasure:
      rememberedMeasure === "focused" || rememberedMeasure === "spacious"
        ? rememberedMeasure
        : "balanced",
    practiceVisited: storage.getItem("verbalore-practice-visited") === "1",
    lastPracticeView:
      rememberedPractice === "words" || rememberedPractice === "expression"
        ? rememberedPractice
        : "discover",
    theme: rememberedTheme === "night" ? "night" : "paper",
  };
}
